import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const MenuItemStyle = styled.li`
  font-family: 'Roboto Slab', serif;
  color: #fff;
  font-size: 16px;
  margin: 0 5px;
  text-align: center;
  display:flex;

  &:hover {
    opacity: 1;
  }

  &:after {
    border-bottom: solid 2px #009fbe;
    content: '';
    display: block;
    margin-top: 3px;
    transform: scaleX(0);
    transition: transform .125s ease-in-out;
  }

  &:hover:after {
    transform: scaleX(1);
  }

  & > svg {
    margin-right: 8px;
  }
`

const MenuItem = ( { href, text, isExternal, 'icon': Icon } ) => {
  if ( isExternal ) {
    return (
      <a
        data-testid={ `a-${text}` }
        href={ href }
        className={ `menu-link__${text[ 0 ].toLowerCase()}` }
      >
        <MenuItemStyle
          data-testid={ `li-${text}` }
        >
          {Icon && <Icon />}
          { text }
        </MenuItemStyle>
      </a>
    )
  } else {
    return (
      <Link
        data-testid={ `a-${text}` }
        to={ href }
        className={ `menu-link__${text[ 0 ].toLowerCase()}` }
      >
        <MenuItemStyle
          data-testid={ `li-${text}` }
        >
          {Icon && <Icon />}
          { text }
        </MenuItemStyle>
      </Link>
    )
  }
}

MenuItem.propTypes = {
  'href': PropTypes.string.isRequired,
  'icon': PropTypes.oneOfType( [ PropTypes.func, PropTypes.bool ] ).isRequired,
  'isExternal': PropTypes.bool,
  'text': PropTypes.string.isRequired,
}

MenuItem.defaultProps = {
  'isExternal': true
}

export default MenuItem
